import type { Bonus, CostRow, FaqItem, Pocket, Testimonial, Volume } from '../types/content';
export const brand = {
  name: 'Full Tienda',
  product: 'Sistema de Ahorro',
  method: 'El Método de los 4 Bolsillos',
  email: 'soporte.fulltienda@gmail.com',
  instagram: '@fulltiendaok',
  site: '\n'
};
export const pricing = {
  anchor: 39900,
  price: 19900,
  currency: 'ARS'
};
export const heroImage = 'https://cdn.magicpatterns.com/patterns/generated-images/2a734168-7ffb-4bdf-8e12-e4eb0852a744.jpg';
export const pocketsImage = 'https://cdn.magicpatterns.com/patterns/generated-images/f89224a7-d8bd-49ba-b2e7-a402f8f2d351.jpg';
export const pockets: Pocket[] = [{
  id: '01',
  name: 'Bolsillo cotidiano',
  role: 'Lo de todos los días',
  description: 'Los gastos necesarios para vivir y funcionar cada día: alimentos, transporte, medicamentos y otros consumos habituales.'
}, {
  id: '02',
  name: 'Bolsillo de obligaciones',
  role: 'Lo que hay que pagar',
  description: 'Los compromisos que deben pagarse durante el mes: alquiler, servicios, cuotas, impuestos, tarjetas y deudas.'
}, {
  id: '03',
  name: 'Bolsillo de seguridad',
  role: 'Lo que te protege',
  description: 'El dinero reservado para afrontar emergencias e imprevistos sin tener que endeudarte ni desarmar todos tus planes.'
}, {
  id: '04',
  name: 'Bolsillo de objetivos',
  role: 'Lo que querés lograr',
  description: 'Tus metas personales y familiares: una compra importante, un viaje, mejorar tu vivienda o construir ahorros a largo plazo.'
}];
export const volumes: Volume[] = [{
  number: 1,
  title: 'Poné en orden tu dinero',
  subtitle: 'Diagnóstico y presupuesto',
  description: 'Registrás tus gastos, reconocés patrones, calculás cuánto necesitás para cubrir tus obligaciones y armás un presupuesto que puedas cumplir.',
  includes: ['Registro de gastos paso a paso', 'Cálculo de tu piso mensual real', 'Presupuesto sostenible con tus números']
}, {
  number: 2,
  title: 'Ahorrá aunque ganes poco',
  subtitle: 'El hábito antes del monto',
  description: 'Métodos concretos para separar una parte de tus ingresos, fijar objetivos y sostener el hábito sin abandonar ante el primer inconveniente.',
  includes: ['Tres formas de separar el ahorro', 'Metas chicas con avance visible', 'Creencias que bloquean el ahorro']
}, {
  number: 3,
  title: 'Deudas bajo control',
  subtitle: 'Cuotas, tarjetas y prioridades',
  description: 'Ordenás tus deudas, entendés su impacto real, establecés prioridades y armás un plan progresivo para reducirlas.',
  includes: ['Mapa completo de tus deudas', 'Orden de pago según impacto', 'Plan de salida mes por mes']
}, {
  number: 4,
  title: 'Construí tu fondo de emergencia',
  subtitle: 'El colchón que sostiene todo',
  description: 'Qué es un fondo de emergencia, cómo calcular una meta adecuada a tu situación, cómo empezar con poco y en qué casos corresponde usarlo.',
  includes: ['Meta calculada sobre tus gastos', 'Arranque con montos mínimos', 'Reglas de uso y reposición']
}, {
  number: 5,
  title: 'Hacé crecer tus ahorros',
  subtitle: 'Inflación, riesgo y liquidez',
  description: 'Conceptos fundamentales y alternativas disponibles en Argentina, explicados en lenguaje sencillo para que puedas decidir según tu perfil.',
  includes: ['Inflación y pérdida de valor', 'Riesgo, plazo y liquidez', 'Opciones locales explicadas simple']
}, {
  number: 6,
  title: 'Tu transformación en 12 meses',
  subtitle: 'El plan anual',
  description: 'Todo lo aprendido se convierte en un plan anual: metas, acciones mensuales y controles periódicos para medir tu avance y ajustar.',
  includes: ['Metas divididas en 12 meses', 'Control mensual de avance', 'Ajustes cuando cambian tus ingresos']
}];
export const bonuses: Bonus[] = [{
  number: 1,
  title: 'Planilla mensual de ingresos y gastos',
  description: 'Registrás movimientos, ordenás categorías y ves con claridad tu economía mes a mes.',
  value: 5900
}, {
  number: 2,
  title: 'Desafío de ahorro de 30 días',
  description: 'Acciones diarias chicas para arrancar, recortar gastos evitables y fijar el hábito.',
  value: 4900
}, {
  number: 3,
  title: 'Calendario de ahorro anual',
  description: 'Objetivos mensuales, registro de avances y tus metas visibles durante todo el año.',
  value: 4900
}, {
  number: 4,
  title: 'Guía para comprar mejor y gastar menos',
  description: 'Comparar precios, planificar compras, detectar falsas ofertas y frenar el impulso.',
  value: 5900
}, {
  number: 5,
  title: '50 ideas para generar ingresos adicionales',
  description: 'Alternativas para distintos conocimientos, recursos y tiempos disponibles. Para analizar, no promesas.',
  value: 6900
}, {
  number: 6,
  title: 'Recetario económico: 30 comidas rendidoras',
  description: 'Organizás las comidas, aprovechás mejor los ingredientes y bajás uno de los gastos más grandes del hogar.',
  value: 5900
}];
export const bonusesTotal = bonuses.reduce((total, bonus) => total + bonus.value, 0);
export const painPoints: string[] = ['Cobrás y a los diez días ya no sabés dónde se fue la plata', 'Llegás a fin de mes ajustando y esperando el próximo ingreso', 'Empezaste a ahorrar varias veces y siempre terminaste usando lo acumulado', 'Las cuotas y la tarjeta se comen una parte fija de lo que entra', 'Un arreglo o un gasto médico te desarma meses de esfuerzo', 'Querés un plan, pero cada consejo que leés arranca con porcentajes que no cierran con tu sueldo'];
export const audience: string[] = ['Trabajás, pero te cuesta llegar con tranquilidad a fin de mes', 'No sabés exactamente en qué se va tu dinero', 'Intentaste ahorrar y terminaste usando lo acumulado', 'Tenés cuotas o deudas que reducen tu capacidad mensual', 'Querés prepararte para imprevistos', 'Necesitás organizar las finanzas de tu hogar', 'Buscás una explicación sencilla, sin tecnicismos innecesarios', 'Querés construir un plan realista con tus propios ingresos', 'Deseás mejorar tu relación con el dinero y decidir con más seguridad'];
export const testimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Mariela G.',
  location: 'Córdoba',
  quote: 'En una tarde ordené todo: cuánto entra, cuánto sale y qué cuota me estaba comiendo el mes. Por primera vez sé con qué cuento.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  quote: 'Los cuatro bolsillos me cambiaron la cabeza. Ahora separo el día que cobro y el ahorro dejó de depender de lo que sobra.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  quote: 'Armé el plan de salida de la tarjeta con el Tomo 3. Bajé dos cuotas en cuatro meses sin dejar de pagar lo de siempre.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  quote: 'Tenía el fondo de emergencia como algo imposible. Empecé con poco y cuando se rompió la heladera no usé la tarjeta.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Neuquén',
  quote: 'La planilla mensual es lo que más uso. Diez minutos por semana y sé exactamente dónde estoy parado.'
}, {
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  quote: 'Lo estamos usando con mi pareja para las cuentas de casa. Dejamos de discutir por plata porque los números están a la vista.'
}];
export const faqs: FaqItem[] = [{
  question: '¿Sirve si gano poco o si mis ingresos son variables?',
  answer: 'Sí. El sistema no reparte tus ingresos con porcentajes fijos: te enseña a asignar cada peso a un bolsillo según tus propios números. Si trabajás por tu cuenta o cobrás montos distintos cada mes, el Tomo 1 incluye el cálculo de tu piso mensual para que puedas planificar sobre lo mínimo y no sobre un promedio optimista.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Es 100% digital en PDF. Después de la compra recibís el acceso por correo en pocos minutos, descargás los 6 tomos y los 6 bonus, y los usás desde el celular, la computadora o impresos. El acceso no vence: los volvés a consultar cuando cambie tu situación.'
}, {
  question: '¿Necesito conocimientos financieros previos?',
  answer: 'No. Todo está explicado de manera directa y progresiva, con situaciones cotidianas, ejemplos con números reales, ejercicios y cuadros de trabajo. Podés avanzar a tu ritmo sin experiencia previa.'
}, {
  question: '¿En qué se diferencia de los consejos gratis de internet?',
  answer: 'La mayoría del contenido financiero recomienda gastar menos o separar un porcentaje fijo, sin contemplar las diferencias entre hogares, salarios, deudas y responsabilidades. Acá cada tomo desarrolla una etapa específica y termina en una acción concreta, para que construyas un sistema personal en lugar de acumular información.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Tenés 7 días para revisar el material completo. Si no es lo que esperabas, te devolvemos el 100% del importe escribiendo a nuestro correo de contacto, sin formularios ni vueltas.'
}];
export const costRows: CostRow[] = [{
  situation: 'Administrar el mes de memoria',
  cost: 'Gastos que no recordás y decisiones tomadas a ciegas'
}, {
  situation: 'Ahorrar con lo que sobra a fin de mes',
  cost: 'Doce meses y el mismo saldo del año pasado'
}, {
  situation: 'Pagar el mínimo de la tarjeta',
  cost: 'Intereses que se acumulan y comprometen tus ingresos futuros'
}, {
  situation: 'No tener fondo de emergencia',
  cost: 'Cada imprevisto se paga con una cuota nueva'
}, {
  situation: 'Dejar el ahorro quieto sin entender la inflación',
  cost: 'El mismo número valiendo menos cada mes'
}];
export const guaranteeStats = [{
  value: '6',
  label: 'Tomos paso a paso'
}, {
  value: '6',
  label: 'Bonus prácticos'
}, {
  value: '12',
  label: 'Meses de plan'
}, {
  value: '7',
  label: 'Días de garantía'
}];